import React, { useState } from "react";
import "./HeroSection.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import Banner1 from "../Component/IMG-20251113-WA0001.jpg";
import Banner2 from "../Component/IMG-20251113-WA0002.jpg";
import Banner3 from "../Component/IMG-20251113-WA0003.jpg";
import Banner4 from "../Component/IMG-20251113-WA0004.jpg";
import Banner5 from "../Component/IMG-20251113-WA0005.jpg";
import Banner6 from "../Component/IMG-20251113-WA0006.jpg";
import Banner7 from "../Component/IMG-20251113-WA0007.jpg";
import Banner8 from "../Component/IMG-20251113-WA0008.jpg";
import Banner9 from "../Component/IMG-20251113-WA0009.jpg";
import Banner10 from "../Component/IMG-20251113-WA0010.jpg";
import overlaytop from "../Component/overlay-top.png";

const HeroSection = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("Courses");

  const bannerImages = [
    Banner1, Banner2, Banner3, Banner4, Banner5,
    Banner6, Banner7, Banner8, Banner9, Banner10
  ];

  const courses = [
    "O-Level",
    "CCC (Course on Computer Concepts)",
    "ADCA (Advanced Diploma in Computer Applications)",
    "PGDCA (Post Graduate Diploma in Computer Applications)",
    "Tally & Communication",
    "Spoken English" 
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching for:", searchQuery, "in", selectedCourse);
    // Add your search logic here
  };

  const handleCourseSelect = (course) => {
    setSelectedCourse(course);
  };

  return (
    <div className="hero-section">
      {/* Swiper Slider */}
      <Swiper
        modules={[Autoplay, Navigation]}
        navigation={true}
        autoplay={{ 
          delay: 3500,
          disableOnInteraction: false 
        }}
        loop={true}
        speed={800}
        slidesPerView={1}
        className="hero-swiper"
      >
        {bannerImages.map((banner, index) => (
          <SwiperSlide key={index}>
            <div className="hero-slide">
              <img 
                src={banner} 
                alt={`CPIT Banner ${index + 1}`} 
                className="hero-img"
                loading={index === 0 ? "eager" : "lazy"}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Dark Overlay */}
      <div className="hero-overlay"></div>

      {/* Center Search Bar */}
      <div className="hero-content">
        <form onSubmit={handleSearch}>
          <div className="transparent-input-group">
            {/* Dropdown Button */}
            <div className="dropdown">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="courseDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {selectedCourse}
              </button>

              {/* Dropdown Menu */}
              <ul className="dropdown-menu transparent-dropdown" aria-labelledby="courseDropdown">
                {courses.map((course, index) => (
                  <li key={index}>
                    <button
                      className="dropdown-item"
                      type="button"
                      onClick={() => handleCourseSelect(course)}
                    >
                      {course}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Search Input */}
            <input 
              type="text" 
              className="form-control" 
              placeholder="Search courses, skills..." 
              aria-label="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            {/* Search Button */}
            <button 
              className="btn btn-outline-light" 
              type="submit"
            >
              Search
            </button>
          </div>
        </form>
      </div>

      {/* Bottom Curve Overlay */}
      <div
        className="overlay-bottom"
        style={{ backgroundImage: `url(${overlaytop})` }}
      ></div>
    </div>
  );
};

export default HeroSection;